import { render, staticRenderFns } from "./administracion-equipos.vue?vue&type=template&id=6908fe3f&scoped=true&"
import script from "./administracion-equipos.vue?vue&type=script&lang=js&"
export * from "./administracion-equipos.vue?vue&type=script&lang=js&"
import style0 from "./administracion-equipos.vue?vue&type=style&index=0&id=6908fe3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6908fe3f",
  null
  
)

export default component.exports